export const sbuICLMock = {
  title: 'SBU',
  type: 'SBU',
  navigation: {
    type: 'GraphMenu',
    nav: [
      {
        title: 'Sales',
        data: {
          month: [
            //   {
            //     title: 'LY',
            //     graph: {
            //       data: [
            //         {
            //           colNames: [
            //             "ACT",
            //             "LM"
            //           ],
            //           data: [
            //             {
            //               title: '',
            //               data: [
            //                 {
            //                   title: '', //String;
            //                   value: 0, //number;
            //                   columns: [], //number[]; //in order according to outer array
            //                   negative: false, //boolean;
            //                   size: 2, //number;
            //                 },
            //                 {
            //                   title: '', //String;
            //                   value: 0, //number;
            //                   columns: [], //number[]; //in order according to outer array
            //                   negative: false, //boolean;
            //                   size: 2, //number;
            //                 },
            //               ],
            //             },
            //           ],
            //         },
            //       ],
            //     },
            //   },
            {
              title: 'C',
              graph: {
                colNames: ['ACT', 'LM'],
                data: [
                  {
                    title: 'IP',
                    data: [
                      {
                        title: 'BR',
                        value: 0,
                        columns: [130.0, 172.0],
                      },
                      {
                        title: 'P',
                        value: -55.0,
                        columns: [146.0, 108.0],
                      },
                      {
                        title: 'SM',
                        value: -224.0,
                        columns: [124.0, 163.0],
                      },
                    ],
                  },
                  {
                    title: 'POTASH',
                    data: [
                      {
                        title: 'COM',
                        value: -1.0,
                        columns: [45.0, 231.0],
                      },
                      {
                        title: 'SPE',
                        value: 3.0,
                        columns: [67.0, 165.0],
                      },
                    ],
                  },
                  {
                    title: 'PS',
                    data: [
                      {
                        title: 'ADS',
                        value: 313.0,
                        columns: [233.0, 78.0],
                      },
                      {
                        title: 'AMF',
                        value: 22.0,
                        columns: [66.0, 321.0],
                      },
                      {
                        title: 'BLB',
                        value: 1.0,
                        columns: [23.0, 44.0],
                      },
                      {
                        title: 'FEQ',
                        value: 54,
                        columns: [323.0, 333.0],
                      },
                      {
                        title: 'SF',
                        value: 45,
                        columns: [443.0, 223.0],
                      },
                    ],
                  },
                  {
                    title: 'GS',
                    data: [
                      {
                        title: 'BR',
                        value: 11.0,
                        columns: [33.0, 13.0],
                      },
                      {
                        title: 'P',
                        value: -4.0,
                        columns: [764.0, 343.0],
                      },
                      {
                        title: 'SM',
                        value: 55.0,
                        columns: [234.0, 55.0],
                      },
                    ],
                  },
                ],
              },
            },
            //   {
            //     title: 'BGT',
            //     graph: {
            //       data: [
            //           {
            //               colNames: [],
            //               data: [
            //                 {
            //                   title: '',
            //                   data: [
            //                     {
            //                       title: '', //String;
            //                       value: 0, //number;
            //                       columns: [], //number[]; //in order according to outer array
            //                       negative: false, //boolean;
            //                       size: 2, //number;
            //                     },
            //                     {
            //                       title: '', //String;
            //                       value: 0, //number;
            //                       columns: [], //number[]; //in order according to outer array
            //                       negative: false, //boolean;
            //                       size: 2, //number;
            //                     },
            //                   ],
            //                 },
            //               ],
            //             },
            //       ],
            //     },
            //   },
          ],
        },
      },
      {
        title: 'OI',
        data: {
          month: [
            //   {
            //     title: 'LY',
            //     graph: {
            //       data: [
            //         {
            //           colNames: [
            //             "ACT",
            //             "LM"
            //           ],
            //           data: [
            //             {
            //               title: '',
            //               data: [
            //                 {
            //                   title: '', //String;
            //                   value: 0, //number;
            //                   columns: [], //number[]; //in order according to outer array
            //                   negative: false, //boolean;
            //                   size: 2, //number;
            //                 },
            //                 {
            //                   title: '', //String;
            //                   value: 0, //number;
            //                   columns: [], //number[]; //in order according to outer array
            //                   negative: false, //boolean;
            //                   size: 2, //number;
            //                 },
            //               ],
            //             },
            //           ],
            //         },
            //       ],
            //     },
            //   },
            {
              title: 'C',
              graph: {
                colNames: ['ACT', 'LM'],
                data: [
                  {
                    title: 'IP',
                    data: [
                      {
                        title: 'BR',
                        value: -24.0,
                        columns: [130.0, 172.0],
                      },
                      {
                        title: 'P',
                        value: 35.0,
                        columns: [146.0, 108.0],
                      },
                      {
                        title: 'SM',
                        value: -24.0,
                        columns: [124.0, 163.0],
                      },
                    ],
                  },
                  {
                    title: 'POTASH',
                    data: [
                      {
                        title: 'COM',
                        value: 1.0,
                        columns: [45.0, 231.0],
                      },
                      {
                        title: 'SPE',
                        value: 3.0,
                        columns: [67.0, 165.0],
                      },
                    ],
                  },
                  {
                    title: 'PS',
                    data: [
                      {
                        title: 'ADS',
                        value: 313.0,
                        columns: [233.0, 78.0],
                      },
                      {
                        title: 'AMF',
                        value: 22.0,
                        columns: [66.0, 321.0],
                      },
                      {
                        title: 'BLB',
                        value: 1.0,
                        columns: [23.0, 44.0],
                      },
                      {
                        title: 'FEQ',
                        value: 54,
                        columns: [323.0, 333.0],
                      },
                      {
                        title: 'SF',
                        value: 45,
                        columns: [443.0, 223.0],
                      },
                    ],
                  },
                  {
                    title: 'GS',
                    data: [
                      {
                        title: 'BR',
                        value: 11.0,
                        columns: [33.0, 13.0],
                      },
                      {
                        title: 'P',
                        value: 34.0,
                        columns: [764.0, 343.0],
                      },
                      {
                        title: 'SM',
                        value: 55.0,
                        columns: [234.0, 55.0],
                      },
                    ],
                  },
                ],
              },
            },
            //   {
            //     title: 'BGT',
            //     graph: {
            //       data: [
            //           {
            //               colNames: [],
            //               data: [
            //                 {
            //                   title: '',
            //                   data: [
            //                     {
            //                       title: '', //String;
            //                       value: 0, //number;
            //                       columns: [], //number[]; //in order according to outer array
            //                       negative: false, //boolean;
            //                       size: 2, //number;
            //                     },
            //                     {
            //                       title: '', //String;
            //                       value: 0, //number;
            //                       columns: [], //number[]; //in order according to outer array
            //                       negative: false, //boolean;
            //                       size: 2, //number;
            //                     },
            //                   ],
            //                 },
            //               ],
            //             },
            //       ],
            //     },
            //   },
          ],
        },
      },
      {
        title: 'EBITDA',
        data: {
          month: [
            //   {
            //     title: 'LY',
            //     graph: {
            //       data: [
            //         {
            //           colNames: [
            //             "ACT",
            //             "LM"
            //           ],
            //           data: [
            //             {
            //               title: '',
            //               data: [
            //                 {
            //                   title: '', //String;
            //                   value: 0, //number;
            //                   columns: [], //number[]; //in order according to outer array
            //                   negative: false, //boolean;
            //                   size: 2, //number;
            //                 },
            //                 {
            //                   title: '', //String;
            //                   value: 0, //number;
            //                   columns: [], //number[]; //in order according to outer array
            //                   negative: false, //boolean;
            //                   size: 2, //number;
            //                 },
            //               ],
            //             },
            //           ],
            //         },
            //       ],
            //     },
            //   },
            {
              title: 'C',
              graph: {
                colNames: ['ACT', 'LM'],
                data: [
                  {
                    title: 'IP',
                    data: [
                      {
                        title: 'BR',
                        value: -24.0,
                        columns: [130.0, 172.0],
                      },
                      {
                        title: 'P',
                        value: -55.0,
                        columns: [146.0, 108.0],
                      },
                      {
                        title: 'SM',
                        value: -224.0,
                        columns: [124.0, 163.0],
                      },
                    ],
                  },
                  {
                    title: 'POTASH',
                    data: [
                      {
                        title: 'COM',
                        value: 1.0,
                        columns: [45.0, 231.0],
                      },
                      {
                        title: 'SPE',
                        value: 3.0,
                        columns: [67.0, 165.0],
                      },
                    ],
                  },
                  {
                    title: 'PS',
                    data: [
                      {
                        title: 'ADS',
                        value: 313.0,
                        columns: [233.0, 78.0],
                      },
                      {
                        title: 'AMF',
                        value: 22.0,
                        columns: [66.0, 321.0],
                      },
                      {
                        title: 'BLB',
                        value: 1.0,
                        columns: [23.0, 44.0],
                      },
                      {
                        title: 'FEQ',
                        value: 54,
                        columns: [323.0, 333.0],
                      },
                      {
                        title: 'SF',
                        value: 45,
                        columns: [443.0, 223.0],
                      },
                    ],
                  },
                  {
                    title: 'GS',
                    data: [
                      {
                        title: 'BR',
                        value: 11.0,
                        columns: [33.0, 13.0],
                      },
                      {
                        title: 'P',
                        value: 34.0,
                        columns: [764.0, 343.0],
                      },
                      {
                        title: 'SM',
                        value: 55.0,
                        columns: [234.0, 55.0],
                      },
                    ],
                  },
                ],
              },
            },
            //   {
            //     title: 'BGT',
            //     graph: {
            //       data: [
            //           {
            //               colNames: [],
            //               data: [
            //                 {
            //                   title: '',
            //                   data: [
            //                     {
            //                       title: '', //String;
            //                       value: 0, //number;
            //                       columns: [], //number[]; //in order according to outer array
            //                       negative: false, //boolean;
            //                       size: 2, //number;
            //                     },
            //                     {
            //                       title: '', //String;
            //                       value: 0, //number;
            //                       columns: [], //number[]; //in order according to outer array
            //                       negative: false, //boolean;
            //                       size: 2, //number;
            //                     },
            //                   ],
            //                 },
            //               ],
            //             },
            //       ],
            //     },
            //   },
          ],
        },
      },

    ],
  },
};
